module.exports = "<div *ngIf=\"router.url !== '/' && !router.url.includes('slideshow')\">\n  <app-header></app-header>\n  <app-sidebar></app-sidebar>\n</div>\n\n<div id=\"sitecontent\">\n  <router-outlet></router-outlet>\n</div>\n\n<toaster-container></toaster-container>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.component.html
// module id = efyd
// module chunks = 1